import React, { Component } from "react";
import {format} from 'date-fns'
import { Modal, Button } from 'react-bootstrap';

class CreditUsages extends Component {
    render() {
        return (
            <div>
                <Modal
                    aria-labelledby="contained-modal-title-vcenter"
                    centered 
                    show={this.props.show} 
                    onHide={() => this.props.onHide({ msg: 'Icon Clicked!' })
                }>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {this.props.title}
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body>

                    <div className="app-card app-card-orders-table mb-5">
                        <div className="app-card-body">
                            <div className="table-responsive">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th className="cell">Type</th>
                                            <th className="cell">Activity</th>
                                            <th className="cell">Credit Deducted</th>
                                            <th className="cell">DateTime</th>                                           
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {this.props.dataCreditUsages && this.props.dataCreditUsages.map((creditUsagesResults, i) => {

                                        //totalPurchase = (parseFloat(totalPurchase) + parseFloat(order.productInfo.price));

                                        let formattedDate = format(new Date(creditUsagesResults.dateTime),"MMM dd, y hh:mm:ss");

                                            return (
                                                <tr key={i}>
                                                    <td className={`text-capitalize`}>{creditUsagesResults.type}</td>
                                                    <td className={`text-capitalize`}>{creditUsagesResults.chatEmail}</td>
                                                    <td>{creditUsagesResults.credits}</td>
                                                    <td>{formattedDate}</td>
                                                </tr>
                                            )
                                        })
                                    }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => this.props.onClick({ msg: 'Modal Closed!' })} >Close</Button>                        
                    </Modal.Footer>

                </Modal>
            </div>
        )
    };
}

export default CreditUsages;